$(document).ready(function() {window.dAgency.collectionCarouselSetup = $context => {
    
    if(!$context || !$context.length) $context = $('body');

    const $articles = $context.find('.articles');

        if($articles.length) {
            $articles.not('.slick-initialized').slick({
            infinite: true,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 1,
            initialSlide: 0,
            dots: false,
            arrows: true,
            centerMode: true,
            centerPadding: '7vw',
            responsive: [
                {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1.2,
                    slidesToScroll: 1,
                    infinite: false,
                    arrows: false,
                    centerMode: false,
                }
                }
            ]
            });
        }
}
window.dAgency.collectionCarouselSetup();
});